import keys from './keys'

const index = [keys.lessThan25k, keys.between25k50k, keys.moreThan50k]

export default index
